import './CardComponent.scss';
import PropTypes from 'prop-types';
import imgNotAvailible from '../../assests/img_not_availible.png';
import { Link } from 'react-router-dom';
import { getRouterForSection, routesMap } from '../../routes';
/**
 * @function CardComponent Card Component
 * @param src
 * @param href
 * @param title
 * @param alt
 * @returns {JSX.Element}
 */
const CardComponent = ( { src, title, alt, tipologia, isDisabled } ) => {
  
  return (
    <div className={ `card-wrapper text-center CardComponent ${ isDisabled ? "disabled" : "" }` }>
        <Link
          to={ getRouterForSection(tipologia) }
          className='card-img no-after special-card CardComponent__Link'>
        <div className='CardComponent__Img'>  
        <img
          src={ src || imgNotAvailible }
          title={ title }
          alt={ alt }
          width={ 94 }
          height={ 105 }
        />
        </div>
        <div className="CardComponent__Title mt-4">{ title }</div>
      </Link>
    </div>
  );
};

CardComponent.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string,
  alt: PropTypes.string
};

CardComponent.defaultProps = {
  src: imgNotAvailible,
};

export default CardComponent;
